<template>
  <div v-if="item" class="mode20-box relative">
    <!-- {{ total }} -->
    <div class="mo20-content">
      <div class="content-desc" @click="toEmail">
        <div class="email-left">
          <img
            class="title-icon"
            v-if="$utils.lang_data(lang, item.list[0] && item.list[0], 'langInfoObj')?.icon"
            :src="$utils.returnImgUrl($utils.lang_data(lang, item.list[0], 'langInfoObj')?.icon)"
            alt
          />
          <span class="title">{{ $utils.lang_data(lang, item.list[0] && item.list[0], "langInfoObj")?.title }}</span>
        </div>
        <!-- <div
          class="email-btn"
          v-if="$utils.lang_data(lang, item.list[0] && item.list[0], 'langInfoObj')?.btnText"
        >
          {{ $utils.lang_data(lang, item.list[0] && item.list[0], "langInfoObj")?.btnText }}
        </div> -->
        <div
          class="email-btn"
        >
          {{ userCoinSymbol }}&nbsp;{{ divideAccuracy(amount, userAccuracy, true) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mode20 from "@/lobby_common/mixins_views/homeModule/mode20.js";
export default {
  mixins: [mode20],
};
</script>
<style lang="scss" scoped>
.mo20-content {
  overflow: hidden;
  padding: 10px 10px 0;
  // margin-top: 12px;
  font-size: 16px;
  color: var(--font-color-200);
  word-wrap: break-word;
  .content-desc {
    padding: 0px 10px;
    height: 27px;
    font-size: 14px;
    background: var(--background-402);
    border-radius: var(--radius-300);
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 5px;
    min-width: 0;
    animation: zoomInOut 1.3s infinite ease-in-out; 
    .email-left {
      display: flex;
      align-items: center;
      gap: 5px;
      min-width: 0; 
      .title-icon {
        height: 20px;
      }
      .title {
        flex: 1;
        min-width: 0;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    .email-btn {
      min-width: 70px;
      font-size: 12px;
      height: 20px;
      padding: 0 10px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      @include buttonPrimary;
      border-radius: var(--radius-300);
    }
  }
}
@keyframes zoomInOut {
  0%, 100% {
    transform: scale(1);   /* 初始大小 */
  }
  50% {
    transform: scale(0.95); /* 放大 */
  }
}
</style>
